<div class="flexRow">

  <dx-select-box
    (onValueChanged)="selectedPeriod = $event.value; changeEvent()"
    [(value)]="selectedPeriod"
    [dataSource]="periodOptions"
    [displayExpr]="translateCronExpr"
    [elementAttr]="{style: 'min-width: 120px'}">
  </dx-select-box>

  <ng-container [ngSwitch]="selectedPeriod">

    <ng-container *ngSwitchCase="'CRON.MINUTE'">

    </ng-container>

    <ng-container *ngSwitchCase="'CRON.HOUR'">
      <span> {{ 'REGISTRY.VIRTUAL_METRICS.TEXT.AT' | translate }} </span>
      <dx-tag-box
        (onValueChanged)="selectedMinute = $event.value; changeEvent()"
        [(value)]="selectedMinute"
        [dataSource]="minuteOptions"
        [elementAttr]="{class: 'cron-tag-box'}"
        [showDropDownButton]="true"
        [showSelectionControls]="true">
      </dx-tag-box>
      <span> {{ 'REGISTRY.VIRTUAL_METRICS.TEXT.MINUTES_PAST_HOUR' | translate }} </span>
    </ng-container>

    <ng-container *ngSwitchCase="'CRON.DAY'">
      <span> {{ 'REGISTRY.VIRTUAL_METRICS.TEXT.AT' | translate }} </span>
      <dx-tag-box
        (onValueChanged)="selectedHour = $event.value; changeEvent()"
        [(value)]="selectedHour"
        [dataSource]="hourOptions"
        [elementAttr]="{class: 'cron-tag-box'}"
        [showDropDownButton]="true"
        [showSelectionControls]="true">
      </dx-tag-box>
      <span>:</span>
      <dx-tag-box
        (onValueChanged)="selectedMinute = $event.value; changeEvent()"
        [(value)]="selectedMinute"
        [dataSource]="minuteOptions"
        [elementAttr]="{class: 'cron-tag-box'}"
        [showDropDownButton]="true"
        [showSelectionControls]="true">
      </dx-tag-box>
    </ng-container>

    <ng-container *ngSwitchCase="'CRON.WEEK'">
      <span> {{ 'REGISTRY.VIRTUAL_METRICS.TEXT.ON' | translate }} </span>
      <dx-tag-box
        (onValueChanged)="selectedWeekday = $event.value; changeEvent()"
        [(value)]="selectedWeekday"
        [dataSource]="weekdaysOptions"
        [displayExpr]="translateCronExpr"
        [elementAttr]="{class: 'cron-tag-box'}"
        [showDropDownButton]="true"
        [showSelectionControls]="true">
      </dx-tag-box>
      <span> {{ 'REGISTRY.VIRTUAL_METRICS.TEXT.AT' | translate }} </span>
      <dx-tag-box
        (onValueChanged)="selectedHour = $event.value; changeEvent()"
        [(value)]="selectedHour"
        [dataSource]="hourOptions"
        [elementAttr]="{class: 'cron-tag-box'}"
        [showDropDownButton]="true"
        [showSelectionControls]="true">
      </dx-tag-box>
      <span>:</span>
      <dx-tag-box
        (onValueChanged)="selectedMinute = $event.value; changeEvent()"
        [(value)]="selectedMinute"
        [dataSource]="minuteOptions"
        [elementAttr]="{class: 'cron-tag-box'}"
        [showDropDownButton]="true"
        [showSelectionControls]="true">
      </dx-tag-box>
    </ng-container>

    <ng-container *ngSwitchCase="'CRON.MONTH'">
      <span> {{ 'REGISTRY.VIRTUAL_METRICS.TEXT.ON_THE' | translate }} </span>
      <dx-tag-box
        (onValueChanged)="selectedDay = $event.value; changeEvent()"
        [(value)]="selectedDay"
        [dataSource]="daysOptions"
        [elementAttr]="{class: 'cron-tag-box'}"
        [showDropDownButton]="true"
        [showSelectionControls]="true">
      </dx-tag-box>
      <span> {{ 'REGISTRY.VIRTUAL_METRICS.TEXT.AT' | translate }} </span>
      <dx-tag-box
        (onValueChanged)="selectedHour = $event.value; changeEvent()"
        [(value)]="selectedHour"
        [dataSource]="hourOptions"
        [elementAttr]="{class: 'cron-tag-box'}"
        [showDropDownButton]="true"
        [showSelectionControls]="true">
      </dx-tag-box>
      <span>:</span>
      <dx-tag-box
        (onValueChanged)="selectedMinute = $event.value; changeEvent()"
        [(value)]="selectedMinute"
        [dataSource]="minuteOptions"
        [elementAttr]="{class: 'cron-tag-box'}"
        [showDropDownButton]="true"
        [showSelectionControls]="true">
      </dx-tag-box>
    </ng-container>

    <ng-container *ngSwitchCase="'CRON.YEAR'">
      <span> {{ 'REGISTRY.VIRTUAL_METRICS.TEXT.ON_THE' | translate }} </span>
      <dx-tag-box
        (onValueChanged)="selectedDay = $event.value; changeEvent()"
        [(value)]="selectedDay"
        [dataSource]="daysOptions"
        [elementAttr]="{class: 'cron-tag-box'}"
        [showDropDownButton]="true"
        [showSelectionControls]="true">
      </dx-tag-box>
      <span> {{ 'REGISTRY.VIRTUAL_METRICS.TEXT.OF' | translate }} </span>
      <dx-tag-box
        (onValueChanged)="selectedMonth = $event.value; changeEvent()"
        [(value)]="selectedMonth"
        [dataSource]="monthsOptions"
        [displayExpr]="translateCronExpr"
        [elementAttr]="{class: 'cron-tag-box'}"
        [showDropDownButton]="true"
        [showSelectionControls]="true">
      </dx-tag-box>
      <span> {{ 'REGISTRY.VIRTUAL_METRICS.TEXT.AT' | translate }} </span>
      <dx-tag-box
        (onValueChanged)="selectedHour = $event.value; changeEvent()"
        [(value)]="selectedHour"
        [dataSource]="hourOptions"
        [elementAttr]="{class: 'cron-tag-box'}"
        [showDropDownButton]="true"
        [showSelectionControls]="true">
      </dx-tag-box>
      <span>:</span>
      <dx-tag-box
        (onValueChanged)="selectedMinute = $event.value; changeEvent()"
        [(value)]="selectedMinute"
        [dataSource]="minuteOptions"
        [elementAttr]="{class: 'cron-tag-box'}"
        [showDropDownButton]="true"
        [showSelectionControls]="true">
      </dx-tag-box>
    </ng-container>

  </ng-container>
</div>
